// Formatare numerica in conventia romaneasca (punct pentru mii, virgula pentru zecimale),
// indiferent de locale-ul browserului vizitatorului.
const nf = new Intl.NumberFormat('ro-RO');

export const formatNumar = (value) => (value == null ? '' : nf.format(value));

// Preturile se afiseaza cu virgula pentru mii (15,800), spre deosebire de km.
const nfPret = new Intl.NumberFormat('en-US');

export const formatPret = (value) => (value == null ? '' : nfPret.format(value));
